import React from 'react';

export function Skeleton({ width, height = 16, borderRadius = 8, style }) {
  return (
    <div className="skeleton-shimmer" style={{
      width: width || '100%', height, borderRadius,
      background: 'var(--skeleton-bg, rgba(255,255,255,0.06))',
      position: 'relative', overflow: 'hidden',
      ...style,
    }} />
  );
}

export function SkeletonCard({ lines = 3, t }) {
  const bg = t?.cardBg || 'rgba(255,255,255,0.05)';
  const border = t?.cardBorder || 'rgba(255,255,255,0.10)';
  return (
    <div style={{
      background: bg, border: `1px solid ${border}`, borderRadius: 20,
      padding: 24, display: 'flex', flexDirection: 'column', gap: 14,
    }}>
      <Skeleton width={140} height={12} />
      {Array.from({ length: lines }).map((_, i) => (
        <Skeleton key={i} width={`${85 - i * 15}%`} height={i === 0 ? 28 : 14} />
      ))}
    </div>
  );
}

export function SkeletonRow({ cols = 6, t }) {
  const bg = t?.rowBg || 'rgba(255,255,255,0.035)';
  const border = t?.rowBorder || 'rgba(255,255,255,0.07)';
  return (
    <div style={{
      background: bg, border: `1px solid ${border}`, borderRadius: 12,
      padding: '12px 16px', display: 'flex', gap: 16, alignItems: 'center',
    }}>
      {Array.from({ length: cols }).map((_, i) => (
        <Skeleton key={i} width={i === 0 ? 60 : i === cols - 1 ? 70 : 80} height={14} />
      ))}
    </div>
  );
}
